import { render, staticRenderFns } from "./exchangeVoucher.vue?vue&type=template&id=5b08c8ca&scoped=true"
import script from "./exchangeVoucher.vue?vue&type=script&lang=js"
export * from "./exchangeVoucher.vue?vue&type=script&lang=js"
import style0 from "./exchangeVoucher.vue?vue&type=style&index=0&id=5b08c8ca&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b08c8ca",
  null
  
)

export default component.exports